import React from 'react';

import { ApIcon } from '@alixpartners/ui-components';
import { Tooltip } from 'react-tippy';
import numeral from 'numeral';
import { HelperText, IconWrapper } from './RowsCount.styles';
import { redDark } from 'styles/colors';

const THRESHOLD = 1048576;
const TOOLTIP_TEXT = `Very large spend cubes of more than ${numeral(
	THRESHOLD
).format(
	'0,0'
)} rows cannot be opened with Microsoft Excel. Select a smaller data set by choosing from the options below.`;

export const RowsCount = ({ count, isTotal, suppressWarning }) => {
	const formattedCount = numeral(count).format('0,0');
	const isWarning = count > THRESHOLD && !suppressWarning;

	return (
		<HelperText isWarning={isWarning}>
			{formattedCount} rows{isTotal ? ' in total' : ''}
			{isWarning && (
				<IconWrapper>
					<Tooltip
						position="top"
						animation="fade"
						arrow
						title={TOOLTIP_TEXT}
						trigger="mouseenter"
					>
						<ApIcon
							iconName="baseline_help_outline"
							iconSize={16}
							iconColor={redDark}
						/>
					</Tooltip>
				</IconWrapper>
			)}
		</HelperText>
	);
};
